import {
    useMemo,
} from 'react'
import moment from 'moment'

import {
    ContainerAvailabilityAllowedProductTypes,
} from 'app/enums/label.enums'
import useLabel from 'app/hooks/useLabel'
import useEnumValues from 'app/hooks/useEnumValues'
import {
    Column,
} from 'app/types/simpletable.types'
import getUniqueId from 'app/utils/getUniqueId'
import {
    dateMask,
} from 'app/utils/date'
import EnumSelector from 'app/shared-components/EnumSelector'
import InputSingleline from 'app/shared-components/InputSingleline'
import Card from 'app/shared-components/Card'
import SimpleTable, {
    RowComponent,
} from 'app/shared-components/SimpleTable'
import {
    WithId,
} from 'app/types/common.types'

import useGetAvailability from '../../hooks/useGetAvailability'
import {
    parseForecastsByProductForInProcess,
    ProcessedContainersByProductRow,
} from './ProcessedContainerByProducts.utils'
import useStyles from './OptimalProcessedContainersByProduct.styles'

export default function OptimalProcessedContainersByProduct({
    id,
}: Readonly<WithId<number>>) {
    const l = useLabel()
    const {
        classes,
    } = useStyles()
    const getAllowedValues = useEnumValues()

    const {
        data,
    } = useGetAvailability({
        serviceCenter: {
            id,
        },
    })

    const config = useMemo(() => {
        if (data) {
            const forecastByProducts = data?.forecastsByProduct.filter((item) => {
                return (item.productType as string) !== 'ALL'
            })
            const result = parseForecastsByProductForInProcess(forecastByProducts)

            return {
                columns: result.columns,
                data: result.data,
            }
        }
        return {
            columns: [],
            data: [],
        }
    }, [data])

    const columns = useMemo((): Column<keyof ProcessedContainersByProductRow>[] => {
        if (config?.columns) {
            return [
                {
                    label: l('PRODUCT_TYPE'),
                    fieldName: 'productType',
                    id: getUniqueId(),
                    component: EnumSelector,
                    getProps: () => {
                        return {
                            className: classes.enumInput,
                            disabled: true,
                            allowedValues:
                                getAllowedValues(ContainerAvailabilityAllowedProductTypes),
                        }
                    },
                },
                ...Array.from(config.columns).map((column) => {
                    return {
                        label: moment(column, dateMask).format('DD.MM'),
                        component: InputSingleline,
                        fieldName: column,
                        id: getUniqueId(),
                        getProps: () => {
                            return {
                                className: classes.numberInput,
                                disabled: true,
                            }
                        },
                    }
                }),
            ]
        }
        return []
    }, [
        l,
        config,
        getAllowedValues,
        classes,
    ])

    return (
        <Card
            title={l('OPTIMAL_PROCESSED_CONTAINERS_BY_PRODUCT')}
            contentClass={classes.cardContent}
        >
            <SimpleTable
                name="OptimalProcessedContainersByProductTable"
                columns={columns}
                data={config?.data}
                component={RowComponent}
                disabled
                classNames={{
                    tableCellHead: classes.tableCellHead,
                    tableCell: classes.tableCell,
                    tableContainer: classes.table,
                }}
            />
        </Card>
    )
}
